import { FieldLabel, Select } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';
import { DecimalPlacesField } from '../shared/DecimalPlacesField.jsx';

export function PivotInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Index (row keys)</FieldLabel>
      <ColSelect value={c.index} onChange={(v) => u({ index: v })} />
      <FieldLabel>Pivot column</FieldLabel>
      <ColSelect value={c.columns_pivot} onChange={(v) => u({ columns_pivot: v })} />
      <FieldLabel>Values</FieldLabel>
      <ColSelect value={c.values} onChange={(v) => u({ values: v })} />
      <FieldLabel>Aggregation</FieldLabel>
      <Select value={c.agg || 'sum'} onChange={(v) => u({ agg: v })}
        options={['sum', 'avg', 'min', 'max', 'count', 'first'].map(v => ({ value: v, label: v }))} />
      {(!c.agg || c.agg === 'sum' || c.agg === 'avg') && (
        <DecimalPlacesField value={c.output_decimals} onChange={(v) => u({ output_decimals: v })} />
      )}
    </div>
  );
}
